import Core from 'core/js/pages/planner/direction-internal-result/_new-search-directions-form'

export default {
  extends: Core,
  template: Core.template,

  methods: {
    ...Core.methods,

    resetOperators() {
      const shouldEnableOperators = !!this.selectedTransports.BUS

      Object.keys(this.selectedOperators).forEach(operatorKey => {
        this.$set(this.selectedOperators, operatorKey, shouldEnableOperators)
      })
    }
  }
}
